import React, {Component} from 'react';
import Socket from "./Socket";
import Logger from "../helpers/Logger";

export default class SocketContainer extends Component {
    componentDidCatch(error, info) {
        const logger = new Logger(this.props.logPath);
        logger.critical('REACT: error caught in Socket', error.toString());
    }

    render() {
        return (<Socket parameters={this.props.parameters} />);
    }
}



// WEBPACK FOOTER //
// ./src/components/SocketContainer.js